import React from 'react';
import { useParams } from 'react-router-dom';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const ReminderList = () => {
  const { activityId } = useParams();

  const decodedActivityId = activityId ? atob(activityId).replace(/\D/g, '') : '';
  const fetchUrl = decodedActivityId
    ? `${API_DOMAIN}${API_ROUTES.customerReminder}?activity=${decodedActivityId}`
    : `${API_DOMAIN}${API_ROUTES.customerReminder}`;

  const columns = [
    { label: 'Reminder Time', value: 'reminder_time' },
    { label: 'Notified', value: item => item.notified ? 'Yes' : 'No' },
    { label: 'Activity', value: item => item.activity?.subject || 'N/A' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/reminder/details/${id}`;
  };

  return (
    <div>
      <h1>Reminders</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default ReminderList;
